import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=47c4cdec&scoped=true&"
import script from "./datepicker.vue?vue&type=script&lang=js&"
export * from "./datepicker.vue?vue&type=script&lang=js&"
import style0 from "./datepicker.vue?vue&type=style&index=0&id=47c4cdec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4cdec",
  null
  
)

export default component.exports